import { CompanyDto } from '../../Api';

export class Company {
    public name: string;
    public constructor(instance: CompanyDto) {
        this.name = instance.name || "";
    }
}